import { render, staticRenderFns } from "./spareGetDetailUpdateNew.vue?vue&type=template&id=3050b7aa"
import script from "./spareGetDetailUpdateNew.vue?vue&type=script&lang=js"
export * from "./spareGetDetailUpdateNew.vue?vue&type=script&lang=js"
import style0 from "./spareGetDetailUpdateNew.vue?vue&type=style&index=0&id=3050b7aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports